export const ShipmentStage = {
  SAVED: 'SAVED',
  LIVE: 'LIVE',
  DELIVERED: 'DELIVERED',
};
